import {Component, EventEmitter, Inject, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DueDiligenceService} from "../../due-diligence.service";

@Component({
  selector: 'app-due-diligence-add-date-modal',
  templateUrl: './due-diligence-add-date-modal.component.html',
  styleUrls: ['./due-diligence-add-date-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DueDiligenceAddDateModalComponent implements OnInit{

  public statuses: any[] = []
  public selectedStatus: any = null
  public selectedDate:string | null = null;
  public onSave: EventEmitter<any> = new EventEmitter()
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data:any, public ddService: DueDiligenceService) {
  }

  ngOnInit() {
    this.ddService.statuses$.subscribe(statuses => {
      if(statuses && statuses.length > 0){
        this.selectedStatus = statuses[0]
      }
    })
  }

  onDateChange(e: any){
    this.selectedDate = e.value
  }



  compareStatuses(a:any, b:any): boolean {
    return a && b && a.id === b.id
  }

  save(){
    if(this.selectedDate!==null && this.selectedStatus!==null){
      let obj = {
        'status' : this.selectedStatus,
        'date' : this.selectedDate
      }
      this.onSave.emit(obj)
      this.dialogRef.close()
    }
  }

  close(){
    this.dialogRef.close()
  }
}
